// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-k_hb","advertDetailHeaderLocation__value":"c-k_hc"};